module.exports = __webpack_public_path__ + "img/animations.30334abd.svg";